/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlaygroundAgentsResponse } from '../../models/playground-agents-response';
import { PlaygroundUpdateAgentsRequest } from '../../models/playground-update-agents-request';

export interface UpdatePlaygroundAgents$Params {
      body: PlaygroundUpdateAgentsRequest
}

export function updatePlaygroundAgents(http: HttpClient, rootUrl: string, params: UpdatePlaygroundAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaygroundAgentsResponse>> {
  const rb = new RequestBuilder(rootUrl, updatePlaygroundAgents.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlaygroundAgentsResponse>;
    })
  );
}

updatePlaygroundAgents.PATH = '/playground/agents';
